import React, { useContext, useEffect, useState } from "react";
import { loadScript, getRazorpayOptions } from "../Utils/razorpay";
import { Button, ButtonGroup, Card, CardBody, CardFooter, Divider, Flex, Heading, Image, Stack, Text } from "@chakra-ui/react";
import axios from "axios";
import { CartContext } from "../context/CartContext";

const Payment = ({ subtotal, tax, totalPrice, cartData, text, reRenderHook }) => {
    const { cart_item: cartlength, checkCartItem } = useContext(CartContext);
    const [payment, setPayment] = useState(null);
    const [error, setError] = useState(null);

    async function buttonClick(e) {
        const newData = cartData.map((e) => {
            let obj = {
                status: false,
                ...e,
                ...text,
            };
            return obj;
        });
        for (let i = 0; i < newData.length; i++) {
            let obj = { ...newData[i] };
            delete obj._id;
            delete obj.userId;
            let data = await axios.post(`${process.env.REACT_APP_BACKEND_API}/order/add`, obj, {
                headers: {
                    Authorization: process.env.REACT_APP_TOKEN,
                },
            });
            await axios.delete(`${process.env.REACT_APP_BACKEND_API}/cart/delete/${newData[i]._id}`, {
                headers: {
                    Authorization: process.env.REACT_APP_TOKEN,
                },
            });
        }
    }

    const handleClick = async (e) => {
        try {
            const Razorpay = await loadScript();
            const options = getRazorpayOptions();
            options.handler = function (response) {
                checkCartItem();

                reRenderHook();
            };
            const razorpayInstance = new Razorpay(options);
            razorpayInstance.open();
            buttonClick(e);
            setPayment(razorpayInstance);
        } catch (err) {
            setError(err);
        }
    };

    return (
        <>
            <Button w="100%" colorScheme="red" isDisabled={cartData == 0 ? true : false} onClick={handleClick}>
                Pay Now
            </Button>
            {error && <p>{error.message}</p>}
        </>
    );
};

export default Payment;
